module.exports = __webpack_public_path__ + "static/4-10c8940fcb3697611d3dbb836ed088ae.png";